import React from 'react';
import SeekerList from './SeekerList';
import { useState } from 'react';
import { csvDownload } from '../../../../dashboard/AdminMetricDashboard/ExportCsv';
import toast from 'react-hot-toast';
import ToastAlert from '../../../../custom-ui/toast-alert/ToastAlert';

const ApplyNowCounterSeekerList = ({companyFullName,jobName, id }: any) => {

    const [applyNowSkrData, setApplyNowSkrData] = useState();
    const handleCsvDownload = () => {
        if (applyNowSkrData) {
            csvDownload(applyNowSkrData, `${companyFullName}_${jobName}_Apply_Now_counter`);
        } else {
            toast.error("No data available for download");
        }

    }
    return (
        <>

            <div className='p-4'>
                {/* header */}
                <div className='w-full flex justify-end items-center'>
                   
                    <button onClick={handleCsvDownload} className='bg-instant-teams-blue-Main text-white px-7 py-1'>
                        Download
                    </button>
                </div>

                <SeekerList jobId={id} setApplyNowSkrData={setApplyNowSkrData} />
            </div>
            <ToastAlert />
        </>
    );
}

export default ApplyNowCounterSeekerList;
